var metaInfo={
    title:"新能源行业解决方案_Movibot解决方案",
    keywords:"新能源电池_分拣、上下料_并联机器人",
    description:"我们的解决方案包括并联机器人为新能源电池提供生产环节中分拣、上下料、视觉识别等服务。",
}

export default {
    metaInfo
  };


// WEBPACK FOOTER //
// ./src/data/metaInfo/11.js